// Add your custom JS here.
/*aos animate */
AOS.init({
    duration: 1000,
    once: true,
});

/**owl carousel */
jQuery(document).ready(function($) {
   var $document = $(document)

   //homepage section two box carousel
    $('.owl-three-boxes').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        dots:false,
        responsive: {
            0: {
                items: 1,
                nav: false,
                dots:true,
                margin: 0,
            },
            600: {
                items: 1,
                nav: false,
                dots:true,
                margin: 0,           
            },
            1000: {
                items: 3,
                loop: false,
                nav: false
            }
        }
    });
    $('.owl-boxes-list').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        dots:false,
        responsive: {
            0: {
                items: 1,
                nav: false,
                dots:true,
                margin: 0,
            },
            600: {
                items: 1,
                nav: false,
                dots:true,
                margin: 0,           
            },
            1000: {
                items: 2,
                loop: false,
                nav: false
            }
        }
    });
    
    //product carousel
    $(".owl-carousel-product").owlCarousel({
          items: 3, // Number of items to display
          loop: false, // Infinite loopss
          margin: 20, // Margin between items
          nav: false, // Show next/prev buttons
          dots:true,
          navText: ["<i class='fas fa-arrow-left'></i>", "<i class='fas fa-arrow-right'></i>"], // Custom navigation arrows
          responsive: {
            0: {
              items: 1, // 1 item for small screens
              nav: false,
              dots:true,
              margin: 0,
          },
          600: {
              items: 2, // 2 items for medium screens
              nav: false,
              dots:true,
              margin: 0,
              
          },
          1000: {
              items: 3, // 4 items for large screens
              dots:true,
          }
      }
  });


        //testimonial carousel
    $(".owl-carousel-testimonial").owlCarousel({
          items: 1, // Number of items to display
          loop: false, // Infinite loop
          margin: 0, // Margin between items
          nav: true, // Show next/prev buttons
          dots:false,
          navText: ["<i class='fas fa-arrow-left'></i>", "<i class='fas fa-arrow-right'></i>"], // Custom navigation arrows
          responsive: {
            0: {
              items: 1, // 1 item for small screens,
              nav: false,
              dots:true,
              margin: 0,
          },
          600: {
              items: 1, // 2 items for medium screens
              nav: false,
              dots:true,
              margin: 0
          },
          1000: {
              items: 1 // 2 items for large screens
          }
      }
  });

    

    
    var selectedGender = [];
    $('.gender-filter').change(function() {
        $('html, body').animate({
            scrollTop: $('#product-listings').offset().top
        }, 1000); //
      var value = $(this).val(); // Get checkbox value

      if($(this).is(':checked')) {
          // Push value to array if checked
          selectedGender.push(value);
      } else {
          // Remove value from array if unchecked
          selectedGender = selectedGender.filter(function(item) {
              return item !== value;
          });
      }
      // console.log(selectedGender); 
      applyFilters(1, selectedGender, selectedMagnifications, selectedColors, wcMinprice, wcMaxprice, selectedOptions)
      // Print the current array
  });

    var selectedMagnifications = [];
    $('.magnify-filter').change(function() {
        $('html, body').animate({
            scrollTop: $('#product-listings').offset().top
        }, 1000); //
    var value = $(this).val(); // Get checkbox value

    if($(this).is(':checked')) {
        // Push value to array if checked
        selectedMagnifications.push(value);
    } else {
        // Remove value from array if unchecked
        selectedMagnifications = selectedMagnifications.filter(function(item) {
            return item !== value;
        });
    }
    applyFilters(1, selectedGender, selectedMagnifications, selectedColors, wcMinprice, wcMaxprice, selectedOptions)
});

    var selectedColors = [];
    $('.color-filter').change(function() {
        $('html, body').animate({
            scrollTop: $('#product-listings').offset().top
        }, 1000); //
    var value = $(this).val(); // Get checkbox value

    if($(this).is(':checked')) {
        // Push value to array if checked
        selectedColors.push(value);
    } else {
        // Remove value from array if unchecked
        selectedColors = selectedColors.filter(function(item) {
            return item !== value;
        });
    }
    applyFilters(1, selectedGender, selectedMagnifications, selectedColors, wcMinprice, wcMaxprice, selectedOptions)
});

    
    var minPrice = parseFloat($('#min-price').val());
    var maxPrice = parseFloat($('#max-price').val());
    var wcMinprice = minPrice;
    var wcMaxprice = maxPrice;

  // Initialize the jQuery UI slider
    $('#slider').slider({
        range: true,
        min: minPrice,
        max: maxPrice,
        values: [minPrice, maxPrice],
        slide: function(event, ui) {
          $('#min-price-value').text(ui.values[0]);
          $('#max-price-value').text(ui.values[1]);
          wcMinprice = parseFloat(ui.values[0]);
          wcMaxprice = parseFloat(ui.values[1]);
      //console.log(wcMinprice, wcMaxprice)
          applyFilters(1, selectedGender, selectedMagnifications, selectedColors, wcMinprice, wcMaxprice, selectedOptions)
      }
  });

  // Set the initial values
    $('#min-price-value').text($('#slider').slider("values", 0));
    $('#max-price-value').text($('#slider').slider("values", 1));



    var selectedOptions;

    $('.woocommerce-ordering #orderby1').on('change',function() {
    // Get the selected value
       selectedOptions = $(this).val();
    // Log the array to the console
   // console.log('Selected sorting options:', selectedOptions);
       applyFilters(1, selectedGender, selectedMagnifications, selectedColors, wcMinprice, wcMaxprice, selectedOptions)

   });
    applyFilters(1, selectedGender, selectedMagnifications, selectedColors, wcMinprice, wcMaxprice, selectedOptions)



    var paged = 1;      
    function applyFilters(paged, selectedGender, selectedMagnifications, selectedColors, wcMinprice, wcMaxprice, selectedOptions) {
      
      // console.log(paged, selectedGender, selectedMagnifications, selectedColors, wcMinprice, wcMaxprice, selectedOptions, productCountArray);
      $('#product-listings').html('<div id="loader" class="loader-container loader-hidden"><div class="loader"></div></div>')
      $('#loader').removeClass('loader-hidden');

      $.ajax({
        url: ajax_filter.ajax_url,
        type: 'POST',
           // dataType: 'json',
        data: {
            action: 'filter_products',
            genders: selectedGender, 
            colors: selectedColors,
            magnifications: selectedMagnifications, 
            min: wcMinprice, 
            max: wcMaxprice, 
            paged: paged,
            orderby : selectedOptions 
        },
        success: function(response) {
            if (response.success) {
                // Update the product listings
                $('#product-listings').html(response.data.product_html);
                // Update pagination
                $('#pagination-2').html(response.data.pagination_html);
                // Update result count
                $('#custom-result-count').text(response.data.result_count);
            }    
        },
        complete: function() {
                $('#loader').addClass('loader-hidden'); // Hide loader
            }
        });
  }
  
  
  $(document).on('click', '#pagination-2 a', function(e) {
    e.preventDefault();
    paged = $(this).attr('href').split('paged=')[1];
    applyFilters(paged, selectedGender, selectedMagnifications, selectedColors, wcMinprice, wcMaxprice, selectedOptions)
});

  



//cart-popup
  var timeout;
  $('.cart-icon').hover(function() {
    clearTimeout(timeout);
    $('.cart-popup').fadeIn();
}, function() {
    timeout = setTimeout(function() {
        $('.cart-popup').fadeOut();
        }, 200); // Delay before hiding
});



// Open filter popup when clicking the filter text on mobile
  $('#filters-toggle').click(function() {
      $('#filters-popup').fadeIn(); // Show the popup
      $('#filters-popup .popup-content').addClass('show');  // Slide in the popup   
      console.log("test");
  });


  // Close the popup when clicking the close button
  $('#close-popup').click(function() {
      $('#filters-popup .popup-content').removeClass('show');  // Slide out the popup
      setTimeout(function() {
          $('#filters-popup').fadeOut();  // Hide the popup after the slide out animation
      }, 300);  // Match the animation duration
  });
  $('#applyFiltersBtn').click(function() {
      $('#filters-popup .popup-content').removeClass('show');  // Slide out the popup
      setTimeout(function() {
          $('#filters-popup').fadeOut();  // Hide the popup after the slide out animation
      }, 300);  // Match the animation duration
  });


  $('#clearFiltersBtn').on('click', function () {
    $('html, body').animate({
        scrollTop: $('#product-listings').offset().top
    }, 1000); //
    // Uncheck all color filter checkboxes
    $('.color-checkbox input[type="checkbox"]').prop('checked', false);
    $('.magnification-checkbox input[type="checkbox"]').prop('checked', false);
    $('.gender-checkbox input[type="checkbox"]').prop('checked', false);
    //console.log("testing");

    applyFilters(1, '', '', '', '', '', '');
});


  function startLoader() {
    // Scroll to the loader div
    const loaderDiv = document.getElementById('product-listing');
    loaderDiv.scrollIntoView({ behavior: 'smooth' });

    // Start the loader (your existing loader logic here)
    loaderDiv.style.display = 'block';
}




document.querySelectorAll('.accordion-button').forEach(function (accordionButton) {
    accordionButton.addEventListener('click', function () {
        const icon = this.querySelector('.toggle-icon');
        if (this.classList.contains('collapsed')) {
            icon.textContent = '+';
        } else {
            icon.textContent = '-';
        }
    });
});

var selectBox = $('.woocommerce-ordering select');

    // Toggle open class on click
    selectBox.on('click', function(event) {
        event.stopPropagation(); // Prevent event bubbling
        $(this).closest('.woocommerce-ordering').toggleClass('open'); // Toggle the open class
    });

    // Close the dropdown if clicking outside
    $(document).on('click', function() {
        $('.woocommerce-ordering').removeClass('open'); // Remove class on document click
    });

    // Close the dropdown when an option is selected
    selectBox.on('change', function() {
        $(this).closest('.woocommerce-ordering').removeClass('open'); // Remove class on option selection
    });

        $('.tabs li').on('click', function() {
            // Remove active class from all tabs
            $('.tabs li').removeClass('active');
            // Add active class to clicked tab
            $(this).addClass('active');
            
            // Hide all tab content
            $('.tab-content .panel').hide();
            // Show the clicked tab's content
            var activeTab = $(this).find('a').attr('href');
            $(activeTab).fadeIn();
            
            return false; // Prevent default anchor behavior
        });

           
function quantityPlus() {
    $('.quantity').on('click', '.plus', function(e) {
        var $input = $(this).prev('input.qty'),
            max = parseFloat( $input.attr( 'max' ) ),
            step = parseInt( $input.attr( 'step' ), 10 ),
            the_val = $input.val().length > 0 ? (parseInt( $input.val(), 10 ) + step ) : (0 + step);

        the_val = the_val > max ? max : the_val;
        $input.val(the_val).change();
    });
}

function quantityMinus() {
    $('.quantity').on('click', '.minus', function(e) {
        var $input = $(this).next('input.qty'),
            min = parseFloat( $input.attr( 'min' ) ),
            step = parseInt( $input.attr( 'step' ), 10 ),
            the_val = $input.val().length > 0 ? parseInt( $input.val(), 10 ) - step : (0 - step);

        the_val = the_val < 0 ? 0 : the_val;
        the_val = the_val < min ? min : the_val;
        $input.val(the_val).change();
    });
};

$document.ajaxComplete(function(){
    initQuantityButtons();
});

$(document.body).on('the7_wc_init_quantity_buttons', function () {
    initQuantityButtons();
});
$document.on('elementor/popup/show',initQuantityButtons);

function initQuantityButtons() {
    var $quantity = $('.quantity');
    $quantity.off('click', '.plus');
    $quantity.off('click', '.minus');
    quantityPlus();
    quantityMinus();
}

initQuantityButtons();


 // Grab all tab buttons (e.g., Description, Additional Information, Reviews)
 const tabButtons = document.querySelectorAll('.wc-tabs li a');
 // Grab all tab content containers
 const tabContents = document.querySelectorAll('.woocommerce-Tabs-panel');

 // Function to activate the selected tab and deactivate others
 function activateTab(tab) {
     // Deactivate all tabs and hide all content
     tabButtons.forEach(button => button.classList.remove('active'));
     tabContents.forEach(content => content.style.display = 'none');

     // Activate the clicked tab
     tab.classList.add('active');
     // Show the corresponding content for the active tab
     const targetTabContent = document.querySelector(tab.getAttribute('href'));
     if (targetTabContent) {
         targetTabContent.style.display = 'block';
     }
 }

 // Add click event listener to each tab button
 tabButtons.forEach(button => {
     button.addEventListener('click', function(event) {
         event.preventDefault();
         activateTab(this); // Activate clicked tab
     });
 });

 // Optionally activate the first tab by default
 if (tabButtons.length > 0) {
     activateTab(tabButtons[0]);
 }

 const additionalTab = document.querySelector('li.additional_information_tab');
 const additionalTabContent = document.querySelector('#tab-additional_information');

 if (additionalTab) {
     additionalTab.style.display = 'none';
 }
 if (additionalTabContent) {
     additionalTabContent.style.display = 'none';
 }
 $('#woocommerce-product-search-field').keyup(function(event) {
    $('#woocommerce-product-search-field').removeClass('focus-search-input');
});

    $('#woocommerce-product-search-field').on('input', function() {
        var query = $(this).val();
        
        if (query.length >= 1) { // Start searching after 2 characters
            $.ajax({
                url: ajax_object.ajax_url,
                type: 'GET',
                data: {
                    action: 'product_search_suggestions', // Our custom action hook
                    query: query
                },
                success: function(response) {
                    if (response.success) {
                        // If results found, show them
                        $('#search-suggestions').html(response.data).show(); 
                        $('#woocommerce-product-search-field').addClass('focus-search-input');
                    } else {
                        // If no results, show a 'No results' message
                        $('#search-suggestions').html('<p>No results found</p>').show();
                    }
                }
            });
        } 
    });

    // Hide suggestions when clicking outside
    $(document).click(function(event) {
        if (!$(event.target).closest('#woocommerce-product-search-form').length) {
            $('#search-suggestions').hide();
        }
    });

}); 

document.querySelector('.input-group-append button').addEventListener('click', function(event) {
    const searchField = document.querySelector('#woocommerce-product-search-field');
    if (!searchField.value.trim()) {
        alert('Please enter a search term!');
        event.preventDefault(); // Prevent form submission if the field is empty
    }
});





